// AdminProfile.jsx

import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Card, CardBody, CardTitle, Form, FormGroup, Label, Input, Spinner, CardSubtitle } from 'reactstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import Avatar from '../avtar/Avatar';
import { isFetching } from 'store/users/actions';
import { useDispatch, useSelector } from 'react-redux';
import createUserSelector from 'store/users/selector';
import ChangePassword from './ChangePassword';

const AdminProfile = ({ isOpen, toggle }) => {
    const dispatch = useDispatch();
    const userSelector = useSelector(createUserSelector);
    const { loginUser } = userSelector;
    const { name, email, role, id, auth } = JSON.parse(localStorage.getItem('user'));
    const [src, setSrc] = useState('');
    const [editAdminData, setEditAdminData] = useState({
        name: loginUser?.name ? loginUser?.name : name,
        email: loginUser?.email ? loginUser?.email : email,
    });
    const [isDisable, setIsDisable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [isOpenChangePass, setIsOpenChangePass] = useState(false);

    const toggleChangePass = () => setIsOpenChangePass(!isOpenChangePass);

    const formData = new FormData();
    const updateAdminDetails = async () => {
        formData.append(`profile_image`, src);
        formData.append('values', JSON.stringify(editAdminData));
        setIsLoading(true);
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/technician/update/${id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }
            );

            if (response.status === 200) {
                toast.success(response.data.message);
                dispatch(isFetching(true));
                toggle();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Error updating admin details:', error);
            toast.error('An error occurred while updating admin details.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleChangeDetails = (e) => {
        setIsDisable(false);

        if (e.target.name === 'name' || e.target.name === 'email') {
            setEditAdminData({
                ...editAdminData,
                [e.target.name]: e.target.value,
            });
        } else {
            setIsDisable(true);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size='lg'>
            <Form>
                <ModalHeader toggle={toggle}>My Account</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs="4">
                            <Card>
                                <Avatar profile_image={loginUser?.profile_image} setIsDisable={setIsDisable} setSrc={setSrc} src={src} />
                                <CardBody className='text-center'>
                                    <CardTitle className='fs-5'>{name}</CardTitle>
                                    <CardSubtitle className="mb-2 text-muted" tag="h6">{loginUser?.role ? loginUser?.role : role}</CardSubtitle>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs="8">
                            {isOpenChangePass ?
                                <ChangePassword id={loginUser ? loginUser?._id : id} token={auth} isOpenChangePass={isOpenChangePass} toggleChangePass={toggleChangePass} />
                                : <Card>
                                    <CardBody>
                                        <FormGroup>
                                            <Label for="editName">Name</Label>
                                            <Input
                                                type="text"
                                                name="name"
                                                placeholder='Name'
                                                id="editName"
                                                value={editAdminData.name}
                                                onChange={handleChangeDetails}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="editEmail">Email</Label>
                                            <div className="input-group has-success">
                                                <Input
                                                    type='text'
                                                    name="email"
                                                    placeholder="Email"
                                                    value={editAdminData.email}
                                                    onChange={handleChangeDetails}
                                                    disabled
                                                />
                                                <Button color="primary" type='button'>@</Button>
                                            </div>
                                        </FormGroup>
                                        <Button color='success' type='button' onClick={toggleChangePass}>Change Account Password</Button>
                                    </CardBody>
                                </Card>}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={toggle}>Cancel</Button>
                    <Button color="primary" onClick={updateAdminDetails} disabled={isDisable}>
                        {isLoading ? (
                            <Spinner color="light" size="sm">Loading...</Spinner>
                        ) : (
                            'Save'
                        )}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default AdminProfile;
